// "Customers also love": the current product's pairings, then similar products, loaded by the shared loader in
// assets/purolabs-cart.js when the section nears the viewport (space is kept for it meanwhile; it hides itself if the
// request fails or returns nothing). The cards' add to cart is assets/purolabs-quick-add.js.
import { Recommendations } from '@purolabs/cart';

class ProductRecommendations extends Recommendations {
  show(nodes) {
    this.replaceChildren(...nodes);
    return Boolean(this.querySelector('.pl-recs__list > li'));
  }
}

if (!customElements.get('pl-product-recommendations')) customElements.define('pl-product-recommendations', ProductRecommendations);
